export const FORM_LOCALIZATION = {
  en: {
    required: "This field is required."
  },
  de: {
    required: "Dieses Feld wird benötigt."
  },
  sv: {
    required: "Fältet är obligatoriskt."
  },
  nl: {
    required: "Dit veld is verplicht."
  },
  it: {
    required: "Questo campo è obbligatorio"
  },
  hu: {
    required: "A mező kitöltése kötelező."
  },
  da: {
    required: "Dette felt er påkrævet."
  },
  fr: {
    required: "Ce champ est obligatoire."
  },
  es: {
    required: "Este dato es obligatorio."
  },
  pl: {
    required: "To pole jest wymagane."
  },
  ro: {
    required: "Acest câmp este obligatoriu."
  },
  hr: {
    required: "Ovo polje je obavezno."
  },
  cs: {
    required: "Toto pole je povinné."
  },
  sl: {
    required: "To polje je obvezno."
  }
};
